import React, { useMemo } from 'react';

import type { useModalsReturnType } from '../hooks/useModals.ts';
import { useModals } from '../hooks/useModals.ts';
import type { DocReducerType } from '../hooks/useUploadReducer.ts';
import { useUploadReducer } from '../hooks/useUploadReducer.ts';

import type { ImportModalTypes } from './Modals/ImportModalTypes.ts';

type ImportStateContextType = useModalsReturnType<ImportModalTypes> & DocReducerType;

export const ImportStateContext: React.Context<ImportStateContextType> =
	React.createContext<ImportStateContextType>({} as ImportStateContextType);

export const ImportStateContextProvider: React.FC<{
	children?: React.ReactNode;
}> = ({ children }) => {
	const { showModal, showConfirmModal, closeModal, updateModalData, modalStack } =
		useModals<ImportModalTypes>();
	const { docs, docActions } = useUploadReducer();

	const contextState = useMemo(
		() => ({
			showModal,
			showConfirmModal,
			closeModal,
			updateModalData,
			modalStack,
			docs,
			docActions,
		}),
		[showModal, showConfirmModal, closeModal, updateModalData, modalStack, docs, docActions],
	);

	return <ImportStateContext.Provider value={contextState}>{children}</ImportStateContext.Provider>;
};
